
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import KacherypladyLandingPage from '../pages/kacherypady-landing/page';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <KacherypladyLandingPage />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
